<app-card appGridItem
          [shadow]="true"
          [column]="5"
          [row]="4"
          [width]="8"
          [height]="2">
  <div class="full-height-stack">

    <!-- Title and separator -->
    <app-card-title size="large">
        <span appPageTitle>
          {{ 'page404.title' | translate }}
        </span>
    </app-card-title>

    <div class="text-center push-top push-bottom">
      {{ 'page404.message' | translate }}<br/><br/>
      {{ 'page404.countdown_message' | translate: {seconds: remainingSeconds} }}
    </div>
  </div>
</app-card>
